<script>
	import listBase from '@_system/components/base/list.vue'
	import invoiceAudit from '@/views/main/finance/invoiceaudit/index.vue';
	export default {
		extends: listBase,
		name: 'invoicetypeIndex',
		props: {

		},
		render(h) {
			this.$slots.plug = [
				<vxe-modal v-model={this.invoiceAuditShow} width="1000" height="800" show-footer destroy-on-close onShow={this.show}
					onHide={this.hide} transfer lock-scroll={false}>
					<template slot="title">
						<div>{this.detailtitle}</div>
					</template>
					<template slot="default">
						<invoice-audit foreingKey={this.foreingKey} />
					</template>
					<template slot="footer">
						<vxe-button status="primary" content="返回" onClick={this.invoiceAuditBack}></vxe-button>
					</template>
				</vxe-modal>,
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				moduleName: 'invoicetype',
				windowName: '发票品类',
				invoiceAuditShow: false,
				detailtitle: '明细'
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			detail(row) {
				this.foreingKey.invoicetypeid = row.id
				this.detailtitle = row.name + '（' + row.code + '）' + '-明细'
				this.invoiceAuditShow = true
			},
			invoiceAuditBack() {
				this.invoiceAuditShow = false
				this.$refs[this.moduleName + '_list'].commitProxy('query')
			},
			show() {

			},
			hide() {

			},
		},
		components: {
			invoiceAudit
		}
	}
</script>
